import { motion } from "framer-motion";

// Light background lotus for light sections (How It Works timeline)
const LOTUS_LIGHT_URL = "https://customer-assets.emergentagent.com/job_transform-life-16/artifacts/5iw6q80j_IMG_7169.jpeg";

// Dark background lotus for dark sections
const LOTUS_DARK_URL = "https://customer-assets.emergentagent.com/job_transform-life-16/artifacts/11sbd929_IMG_7170.jpeg";

export const AnimatedLotus = ({ stage = "closed", size = 120, className = "", variant = "light" }) => {
  // Stage affects opacity and scale for visual progression
  const getStyles = () => {
    switch (stage) {
      case "closed":
        return { scale: 0.8, opacity: 0.4, filter: "blur(2px) grayscale(30%)" };
      case "opening":
        return { scale: 0.9, opacity: 0.7, filter: "blur(1px) grayscale(15%)" };
      case "bloomed":
        return { scale: 1, opacity: 1, filter: "blur(0px) grayscale(0%)" };
      default:
        return { scale: 1, opacity: 1, filter: "blur(0px) grayscale(0%)" };
    }
  };

  const styles = getStyles();
  const logoUrl = variant === "dark" ? LOTUS_DARK_URL : LOTUS_LIGHT_URL;
  const blendMode = variant === "dark" ? "lighten" : "multiply";

  return (
    <motion.div
      className={`relative flex items-center justify-center ${className}`}
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ 
        scale: styles.scale, 
        opacity: styles.opacity,
        filter: styles.filter
      }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <img 
        src={logoUrl}
        alt="Lotus"
        style={{ 
          height: size, 
          width: 'auto',
          objectFit: 'contain',
          mixBlendMode: blendMode
        }}
      />
      
      {/* Glow effect for bloomed state */}
      {stage === "bloomed" && (
        <motion.div
          className="absolute inset-0 rounded-full pointer-events-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{
            background: "radial-gradient(circle, rgba(245,168,130,0.15) 0%, transparent 70%)",
            filter: "blur(20px)",
          }}
        />
      )}
    </motion.div>
  );
};
